module.exports = __webpack_public_path__ + "media/images/landing/how_we_do_it_bg-bc57d828c5bbb954133499a9f4431e9b.jpg";